import React, { PropsWithChildren, ReactElement } from 'react';
import classnames from 'classnames';
import { Icon } from '../Icon';
import { IconButton } from '../IconButton';
import styles from './index.module.css';

type AlertColours =
  | 'info'
  | 'warning'
  | 'warning-alt'
  | 'success'
  | 'dark'
  | 'light';

type IconNames =
  | 'info-outline'
  | 'warning-outline'
  | 'check-outline'
  | 'help-outline'
  | 'info';

type IconNamesMap = {
  [K in AlertColours]: IconNames;
};

export type AlertProps = PropsWithChildren<{
  className?: string;
  colour?: AlertColours;
  onDismiss?: () => void | null;
  showIcon?: boolean;
}>;

const ICONS: IconNamesMap = {
  dark: 'help-outline',
  info: 'info-outline',
  light: 'help-outline',
  success: 'check-outline',
  warning: 'warning-outline',
  'warning-alt': 'warning-outline',
};

export function Alert({
  showIcon = false,
  children,
  className,
  colour = 'info',
  onDismiss,
}: AlertProps): ReactElement {
  const classes = classnames('alert', className, {
    [`alert--${colour}`]: !!colour,
  });

  const iconName: IconNames = ICONS[colour] || 'info';

  return (
    <div className={classes} role="alert">
      {showIcon && (
        <div className="alert__icon">
          <Icon name={iconName} />
        </div>
      )}
      <div className="alert__message">{children}</div>
      {onDismiss && (
        <span className={styles.close}>
          <IconButton
            className="alert__close"
            icon="close"
            colour="link"
            size="large"
            onClick={onDismiss}
          />
        </span>
      )}
    </div>
  );
}
